import React, { memo } from 'react';
import { Button } from '@common/components/button';
import BlocksBar from '@modules/performance/components/block-bar/block-bar';
import Tooltip from '@common/components/tooltip';
import { useTranslation } from 'react-i18next';

interface CategoryHeaderProps {
  categoryName: string;
  totalBlocks: number;
  averageFilled: number;
  color: string;
  onShowRatingScales: () => void;
}

const CategoryHeader = memo<CategoryHeaderProps>(({
  categoryName,
  totalBlocks,
  averageFilled,
  color,
  onShowRatingScales,
}) => {
  const { t } = useTranslation();

  return (
    <div className="tw-flex tw-flex-row tw-items-center tw-gap-3">
      <div className="tw-text-gray-textDark tw-text-xl tw-font-semibold">
        {categoryName}
      </div>
      <div className="tw-w-[1px] tw-h-4 tw-flex tw-flex-col tw-bg-gray-border" />
      <BlocksBar
        total={totalBlocks}
        filled={averageFilled}
        color={color}
      />
      <div className="tw-w-[1px] tw-h-4 tw-flex tw-flex-col tw-bg-gray-border" />
      <Tooltip title={t('performance:show_rating_scale_descriptions')}>
        <Button
          icon="list_number"
          size="default"
          className="!tw-p-0 !tw-text-gray-textGray"
          onClick={onShowRatingScales}
        />
      </Tooltip>
    </div>
  );
});

CategoryHeader.displayName = 'CategoryHeader';

export default CategoryHeader;
